import { render, staticRenderFns } from "./form-dropdown.vue?vue&type=template&id=50744115&scoped=true"
import script from "./form-dropdown.vue?vue&type=script&lang=js"
export * from "./form-dropdown.vue?vue&type=script&lang=js"
import style0 from "./form-dropdown.vue?vue&type=style&index=0&id=50744115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50744115",
  null
  
)

export default component.exports